/*
  Coloris sur une ligne (19/10/2026).

  1. Cartes produit : les pastilles ne passent jamais à la ligne. Le CSS les coupe
     dès le premier affichage (theme.css.liquid, section 25) ; ici on cache celles
     qui ne tiennent pas, de la fin vers le début, et on ajoute « +N ». Les épuisés
     sont déjà en fin de ligne (order:1, posé par product-grid-item.liquid), ce sont
     donc eux qui partent en premier. Le coloris actif n'est jamais caché.
     « +N » est un <span> et non un lien : dans outlet-grid, les pastilles sont DANS
     le lien de la carte, et un lien dans un lien est invalide. Ailleurs, un clic
     suit le lien de la carte (qui porte la variante choisie).
     Il est masqué aux lecteurs d'écran : la carte a déjà son lien vers la fiche.

  2. Fiche produit : les vignettes de coloris défilent en bande (variant-button.liquid).
     On ramène le coloris choisi dans la partie visible, et on ajoute deux flèches
     pour la souris, qui ne sait pas faire défiler une bande horizontale. Au clavier,
     les flèches du clavier passent d'un coloris à l'autre et le navigateur suit.

  Les cartes arrivent aussi après le chargement (filtres AJAX, recommandations,
  vus récemment) : un MutationObserver les prend en charge. Un ResizeObserver
  recalcule quand la largeur change, y compris d'un bloc d'abord masqué (largeur 0).
*/
(function () {
  if (window.__eikenColoris) return;
  window.__eikenColoris = true;

  var ordre = function (el) { return parseInt(getComputedStyle(el).order, 10) || 0; };

  /* ---------- 1. Cartes ---------- */

  function ligne(c) {
    var largeur = c.parentElement ? c.parentElement.clientWidth : 0;
    if (!largeur || largeur === c.__eikenLargeur) return;
    c.__eikenLargeur = largeur;

    var plus = c.querySelector('.grid-product__colors-more');
    var pastilles = Array.prototype.slice.call(c.querySelectorAll(':scope > .color-swatch--small'));
    pastilles.forEach(function (p) { p.classList.remove('is-hors-ligne'); });
    if (plus) plus.hidden = true;
    if (c.scrollWidth <= c.clientWidth + 1) return;

    // ordre d'affichage : propriété order, puis ordre du DOM
    var vues = pastilles
      .map(function (p, i) { return { p: p, o: ordre(p), i: i }; })
      .sort(function (a, b) { return a.o - b.o || a.i - b.i; })
      .map(function (x) { return x.p; });

    if (!plus) {
      plus = document.createElement('span');
      plus.className = 'grid-product__colors-more';
      plus.setAttribute('aria-hidden', 'true');
      c.appendChild(plus);
    }
    plus.hidden = false;

    var caches = 0;
    for (var k = vues.length - 1; k > 0; k--) {
      if (vues[k].classList.contains('is-active')) continue;
      vues[k].classList.add('is-hors-ligne');
      caches++;
      plus.textContent = '+' + caches;
      if (c.scrollWidth <= c.clientWidth + 1) break;
    }
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('.grid-product__colors-more');
    if (!plus) return;
    if (plus.closest('a')) return; // outlet-grid : le lien parent fait le travail
    var carte = plus.closest('.grid-product');
    var lien = carte && carte.querySelector('.grid-product__link');
    if (lien) window.location.href = lien.href;
  });

  /* ---------- 2. Fiche produit ---------- */

  var souris = window.matchMedia('(hover: hover) and (pointer: fine)');
  var chevron = function (d) {
    return '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="' + d +
      '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };

  function montrerChoisi(fs, doux) {
    var coche = fs.querySelector('input:checked + label');
    if (!coche) return;
    var bande = fs.getBoundingClientRect(), v = coche.getBoundingClientRect();
    var marge = 8, cible = null;
    if (v.left < bande.left + marge) cible = fs.scrollLeft + v.left - bande.left - marge;
    else if (v.right > bande.right - marge) cible = fs.scrollLeft + v.right - bande.right + marge;
    if (cible !== null) fs.scrollTo({ left: cible, behavior: doux ? 'smooth' : 'auto' });
  }

  function fleches(fs) {
    var bloc = fs.closest('.variant-wrapper');
    if (!bloc) return;
    var prec = bloc.querySelector('.coloris-fleche--prec');
    var suiv = bloc.querySelector('.coloris-fleche--suiv');
    var deborde = fs.scrollWidth > fs.clientWidth + 1;
    if (!souris.matches || !deborde) {
      if (prec) prec.hidden = true;
      if (suiv) suiv.hidden = true;
      return;
    }
    if (!prec) {
      if (getComputedStyle(bloc).position === 'static') bloc.style.position = 'relative';
      var fabrique = function (sens, d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'coloris-fleche coloris-fleche--' + sens;
        b.tabIndex = -1;
        b.setAttribute('aria-hidden', 'true');
        b.innerHTML = chevron(d);
        b.addEventListener('click', function () {
          var pas = fs.clientWidth * 0.8 * (sens === 'prec' ? -1 : 1);
          fs.scrollBy({ left: pas, behavior: 'smooth' });
        });
        bloc.appendChild(b);
        return b;
      };
      prec = fabrique('prec', 'M9 2 4 7l5 5');
      suiv = fabrique('suiv', 'M5 2l5 5-5 5');
    }
    var milieu = fs.offsetTop + fs.offsetHeight / 2;
    prec.style.top = suiv.style.top = milieu + 'px';
    prec.hidden = fs.scrollLeft <= 2;
    suiv.hidden = fs.scrollLeft + fs.clientWidth >= fs.scrollWidth - 2;
  }

  function bande(fs) {
    montrerChoisi(fs, false);
    fleches(fs);
    fs.addEventListener('scroll', function () { fleches(fs); }, { passive: true });
    fs.addEventListener('change', function () { montrerChoisi(fs, true); });
  }

  /* ---------- Branchement ---------- */

  var taille = 'ResizeObserver' in window ? new ResizeObserver(function (entrees) {
    entrees.forEach(function (e) {
      var t = e.target;
      if (t.__eikenColoris) ligne(t.__eikenColoris);
      else if (t.__eikenBande) fleches(t.__eikenBande);
    });
  }) : null;

  function scanner(racine) {
    racine.querySelectorAll('.grid-product__colors').forEach(function (c) {
      if (c.__eikenVu) return;
      c.__eikenVu = true;
      ligne(c);
      if (taille && c.parentElement) { c.parentElement.__eikenColoris = c; taille.observe(c.parentElement); }
    });
    racine.querySelectorAll('fieldset.variant-input-wrap--bande').forEach(function (fs) {
      if (fs.__eikenVu) return;
      fs.__eikenVu = true;
      bande(fs);
      if (taille) { fs.__eikenBande = fs; taille.observe(fs); }
    });
  }

  function demarrer() {
    scanner(document);
    var prevu = false;
    new MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      requestAnimationFrame(function () { prevu = false; scanner(document); });
    }).observe(document.body, { childList: true, subtree: true });
    if (!taille) window.addEventListener('resize', function () {
      document.querySelectorAll('.grid-product__colors').forEach(ligne);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
